<div class="poll-container" *ngIf="isPollListing">

  <div class="poll-card">

    <!-- Header: Edit/Delete Actions -->
    <div class="poll-header flex justify-between items-center mb-3" *ngIf="!hasVoted && onCreationTime">
      <div class="right flex items-center gap-5">
        <button
          type="button"
          class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
          (click)="onEditPoll(isPollListing)"
          ngbTooltip="Edit Poll">
          <i class="bi bi-pencil fs-5 text-black header-icons-font-size cursor-pointer"></i>
        </button>

        <button
          type="button"
          class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
          (click)="onDeletePoll(isPollListing)"
          ngbTooltip="Delete Poll">
          <i class="bi bi-trash fs-5 header-icons-font-size text-red cursor-pointer ml-4"></i>
        </button>
      </div>
    </div>

    <!-- Question -->
    <div class="mb-3 flex justify-between items-center">
      <h6 class="poll-question">{{ isPollListing?.question | titlecase }}</h6>
    </div>

    <!-- Options -->
    <ng-container *ngIf="!hasVoted; else votedTemplate">
      <div
        *ngFor="let option of isPollListing?.options"
        class="poll-option-notselected mt-3 w-full"
        (click)="!onCreationTime && onVote(option)">
        <span class="poll-option-text-notselected">
          {{ option.optionText || '' }}
        </span>
      </div>
    </ng-container>

    <!-- Voted Template -->
    <ng-template #votedTemplate>
      <div class="poll-options">
        <div
          *ngFor="let option of isPollListing?.options"
          class="poll-option mb-3"
          [ngClass]="{ 'selected': selectedOption?.id === option.id }">
          <span class="poll-option-text">
            {{ option.optionText || '' }}
            <span *ngIf="selectedOption?.id === option.id" class="ml-4">
              <i class="bi bi-check-lg poll-check" [ngbTooltip]="'You Voted'"></i>
            </span>
          </span>
          <span class="poll-percentage">{{ option.votePercentage }}%</span>
        </div>
      </div>
    </ng-template>

    <!-- Footer -->
    <div class="poll-footer flex justify-between items-center mt-4 text-sm text-gray-600">
      <span>{{ isPollListing?.totalVotes || 0 }} votes • {{ remainingTimeLabel }}</span>
    </div>

  </div>
</div>
